import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        clusters: false
      },
      options: {
        clusters: []
      },
      selected: {
        cluster: ''
      },
      editable: {
        cluster: ''
      }
    }
  },

  watch: {
    'selected.area' (area) {
      if (area?.id) {
        this.getClusters(this, '', area.id).finally(() => {
          if (this.editable.cluster) {
            this.selected.cluster = QUERY.find(this.options.clusters, {
              id: this.editable.cluster
            }) || ''

            this.editable.cluster = ''
          }
        })
      } else {
        this.selected.cluster = ''
        this.options.clusters = []
      }
    }
  },

  methods: {

    async getClusters (context, search = '', area = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.cluster
      const fetching = context.fetching?.clusters
      const options = context.options?.clusters

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.clusters = true
      context.selected.cluster = ''

      const filters = {
        filter_text: search,
        area_id: area
      }

      return await SSharedList.getClusters(filters).then(
        ({ data }) => {
          context.options.clusters = data
        }
      ).catch(() => {
        context.options.clusters = []
      }).finally(() => {
        context.fetching.clusters = false
      })
    },

    async searchClusters (search, loading) {
      this.searchClustersProvider(this, search, loading)
    },

    searchClustersProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.clusters, {
          keys: ['cluster_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            area_id: selected.area?.id || ''
          }

          SSharedList.getClusters(filters).then(
            ({ data }) => {
              options.clusters = data
            }
          ).catch(() => {
            options.clusters = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
